import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ClipboardModule } from 'ngx-clipboard';

import { CoreModule } from './@core/core.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_CONFIG, NzConfig } from 'ng-zorro-antd/core/config';

import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import zh from '@angular/common/locales/zh';
registerLocaleData(en);
registerLocaleData(zh);

const ngZorroConfig: NzConfig = {
  message: { nzMaxStack: 1 },
  notification: { nzDuration: 10000 },
};

@NgModule({
  declarations: [],
  imports: [AppComponent, AppRoutingModule, BrowserModule, BrowserAnimationsModule, CoreModule, ClipboardModule],
  providers: [{ provide: NZ_CONFIG, useValue: ngZorroConfig }],
  bootstrap: [AppComponent],
})
export class AppModule {}
